import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import WhosHotCard from '../components/shared/WhosHotCard';
import { ArrowLeft, Download } from 'lucide-react';

export default function WhosHotPage() {
  const { teamId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-950 text-white px-4 py-6" data-testid="whos-hot-page">
      <div className="max-w-lg mx-auto space-y-4">
        <div className="flex items-center justify-between">
          <Button
            variant="ghost"
            size="sm"
            className="text-stone-300 hover:text-white hover:bg-stone-800"
            onClick={() => navigate(-1)}
            data-testid="whos-hot-back"
          >
            <ArrowLeft size={14} className="mr-1" /> Back
          </Button>
          <p className="text-xs text-stone-500 uppercase tracking-widest">Diamond Scorer</p>
        </div>

        <WhosHotCard teamId={teamId} compact={false} publicPage={true} />

        <div className="text-center pt-2">
          <p className="text-stone-500 text-xs mb-3">
            Want push alerts when big plays happen in the game? Install the app.
          </p>
          <Button
            variant="outline"
            className="border-stone-700 text-stone-300 hover:bg-stone-800"
            onClick={() => navigate('/')}
            data-testid="whos-hot-cta"
          >
            <Download size={14} className="mr-1" /> Get Diamond Scorer
          </Button>
        </div>
      </div>
    </div>
  );
}
